<div class="page-not-found">
    <img src="/assets/images/not_found_img.svg" />
    <h1>
        Oops!
    </h1>
    <p>The page you are looking for could not be found.</p>
    <button id="pageNotFound" type="button" class="btn btn-blue" (click)="redirectToHome()">Back to Home</button>
</div>